import { request } from "umi";
import { paramsSerializer } from "../../api";

const urlPrefix = "/api/tenant/settings";

// ===== SMS TEMPLATE CATEGORIES =====

export async function getSmsTemplateCategoryListByPage(
  params: API.PageParams & Record<string, any>,
  sort?: any,
  filter?: any,
) {
  return request<API.ResultObject<API.PaginatedResult<API.SmsTemplateCategory>>>(
    `${urlPrefix}/sms-template-categories`,
    {
      method: "GET",
      params: { ...params, perPage: params.pageSize, page: params.current, sort, filter },
      withToken: true,
      paramsSerializer,
    },
  ).then((res) => ({
    data: res.data?.rows ?? [],
    success: res.success ?? false,
    total: res.data?.pagination?.total_records ?? 0,
  }));
}

export async function getAllSmsTemplateCategories() {
  return request<API.ResultObject<API.SmsTemplateCategory[]>>(
    `${urlPrefix}/sms-template-categories/all`,
    { method: "GET", withToken: true },
  );
}

export async function createSmsTemplateCategory(data: Partial<API.SmsTemplateCategory>) {
  return request<API.ResultObject<API.SmsTemplateCategory>>(
    `${urlPrefix}/sms-template-categories`,
    { method: "POST", data, withToken: true },
  );
}

export async function updateSmsTemplateCategory(id: number, data: Partial<API.SmsTemplateCategory>) {
  return request<API.ResultObject<API.SmsTemplateCategory>>(
    `${urlPrefix}/sms-template-categories/${id}`,
    { method: "PUT", data, withToken: true },
  );
}

export async function deleteSmsTemplateCategory(id: number) {
  return request<API.BaseResult>(
    `${urlPrefix}/sms-template-categories/${id}`,
    { method: "DELETE", withToken: true },
  );
}

// ===== SMS TEMPLATES =====

export async function getSmsTemplateListByPage(
  params: API.PageParams & Record<string, any>,
  sort?: any,
  filter?: any,
) {
  return request<API.ResultObject<API.PaginatedResult<API.SmsTemplate>>>(
    `${urlPrefix}/sms-templates`,
    {
      method: "GET",
      params: { ...params, perPage: params.pageSize, page: params.current, sort, filter },
      withToken: true,
      paramsSerializer,
    },
  ).then((res) => ({
    data: res.data?.rows ?? [],
    success: res.success ?? false,
    total: res.data?.pagination?.total_records ?? 0,
  }));
}

export async function getAllSmsTemplates() {
  return request<API.ResultObject<API.SmsTemplate[]>>(
    `${urlPrefix}/sms-templates/all`,
    { method: "GET", withToken: true },
  );
}

export async function createSmsTemplate(data: Partial<API.SmsTemplate>) {
  return request<API.ResultObject<API.SmsTemplate>>(
    `${urlPrefix}/sms-templates`,
    { method: "POST", data, withToken: true },
  );
}

export async function updateSmsTemplate(id: number, data: Partial<API.SmsTemplate>) {
  return request<API.ResultObject<API.SmsTemplate>>(
    `${urlPrefix}/sms-templates/${id}`,
    { method: "PUT", data, withToken: true },
  );
}

export async function deleteSmsTemplate(id: number) {
  return request<API.BaseResult>(
    `${urlPrefix}/sms-templates/${id}`,
    { method: "DELETE", withToken: true },
  );
}

export async function uploadSmsTemplateMedia(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return request<API.ResultObject<{ url: string }>>(
    `${urlPrefix}/sms-templates/upload-media`,
    { method: "POST", data: formData, withToken: true, requestType: "form" },
  );
}

export async function deleteSmsTemplateMedia(url: string) {
  return request<API.BaseResult>(
    `${urlPrefix}/sms-templates/media`,
    { method: "DELETE", data: { url }, withToken: true },
  );
}

// ===== SMS TRIGGER LOGS =====

export async function getSmsTriggerLogListByPage(
  params: API.PageParams & Record<string, any>,
  sort?: any,
  filter?: any,
) {
  return request<API.ResultObject<API.PaginatedResult<API.SmsTriggerLog>>>(
    `${urlPrefix}/sms-trigger-logs`,
    {
      method: "GET",
      params: { ...params, perPage: params.pageSize, page: params.current, sort, filter },
      withToken: true,
      paramsSerializer,
    },
  ).then((res) => ({
    data: res.data?.rows ?? [],
    success: res.success ?? false,
    total: res.data?.pagination?.total_records ?? 0,
  }));
}

// ===== CUSTOMER ROUTE REMINDER LOGS =====

export async function getCustomerRouteReminderLogListByPage(
  params: API.PageParams & Record<string, any>,
  sort?: any,
  filter?: any,
) {
  return request<API.ResultObject<API.PaginatedResult<API.CustomerRouteReminderLog>>>(
    `${urlPrefix}/customer-route-reminder-logs`,
    {
      method: "GET",
      params: { ...params, perPage: params.pageSize, page: params.current, sort, filter },
      withToken: true,
      paramsSerializer,
    },
  ).then((res) => ({
    data: res.data?.rows ?? [],
    success: res.success ?? false,
    total: res.data?.pagination?.total_records ?? 0,
  }));
}
